import { render, staticRenderFns } from "./MarketingCampaignTemplateTabs.vue?vue&type=template&id=0f8862f4"
import script from "./MarketingCampaignTemplateTabs.vue?vue&type=script&lang=js"
export * from "./MarketingCampaignTemplateTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports